
const digest = 'e7c1a396550794943ae0fd244dd5df87d5f9598703cd24e956c9b684a982a6b9';
const classes = {"wrapper":"_wrapper_1jwim_1","form":"_form_1jwim_9","controls":"_controls_1jwim_15","toggleButton":"_toggleButton_1jwim_22","filterInfo":"_filterInfo_1jwim_31","count":"_count_1jwim_39","active":"_active_1jwim_45","activeBadge":"_activeBadge_1jwim_49"};
const css = `._wrapper_1jwim_1 {
  display: flex;
  gap: 24px;
  background-color: #fff;
  border: 1px solid #eaedf3;
  padding: 12px;
  position: relative;
}
._wrapper_1jwim_1 ._form_1jwim_9 {
  flex: 1;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
._wrapper_1jwim_1 ._controls_1jwim_15 {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 180px;
  justify-content: flex-end;
}
._wrapper_1jwim_1 ._controls_1jwim_15 ._toggleButton_1jwim_22 {
  display: flex;
  align-items: center;
  gap: 7px;
}
._wrapper_1jwim_1 ._controls_1jwim_15 ._toggleButton_1jwim_22 img {
  width: 18px;
}

._filterInfo_1jwim_31 {
  display: flex;
  gap: 24px;
  background-color: #fff;
  border: 1px solid #eaedf3;
  border-top: 0;
  padding: 12px;
}
._filterInfo_1jwim_31 ._count_1jwim_39 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
}

._active_1jwim_45 {
  border-bottom: 3px solid #ffa1b0;
}

._activeBadge_1jwim_49 {
  background-color: #f12848;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  padding: 2px 9px;
  border-radius: 10px;
  right: 10px;
  bottom: -11px;
  z-index: 100;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  